import Helper from "./Helper";

class Survey {
	constructor(config = {}) {
		const { formID } = config;

		const form = document.getElementById(formID);
		const popupToggles = Array.prototype.slice.call(document.querySelectorAll('.js-journey-popup-toggle'));

		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);

		const q1 = urlParams.get('q1')
		const q2 = urlParams.get('q2')
		const q3 = urlParams.get('q3')
		const q4 = urlParams.get('q4')
		const q5 = urlParams.get('q5')

		const summary = document.querySelector('.survey-summary');
		if(summary){
			console.log('fill summary');
			summary.querySelector('#q1').value = q1;
			summary.querySelector('#q2').value = q2;
			summary.querySelector('#q3').value = q3;
			summary.querySelector('#q4').value = q4;
			summary.querySelector('#q5').value = q5;
			summary.querySelector('#type').value = document.querySelector('.survey-results__h1').innerText;
		}

		if(popupToggles){
			popupToggles.forEach(toggle => {
				toggle.addEventListener('click', e => {
					const popupClass = toggle.getAttribute('data-toggles-popup');
					Helper.toggleClass(document.querySelector('.'+popupClass), 'active');
					popupToggles.forEach(toggler => {
						if(toggler.getAttribute('data-toggles-popup') == popupClass){
							console.log(toggler);
							if(toggler.classList.contains('active')){
								console.log('has active class');
								toggler.classList.remove('active');
							} else {
								toggler.classList.add('active');
							}
						}
					});
				});
			});
		}

		if(form){
			const submit = form.querySelector('button[type="submit"]');
			console.log(submit);
			submit.addEventListener("click", e => {
				let q1 = this.validateRadios(form, 'q1');
				let q2 = this.validateRadios(form, 'q2');
				let q3 = this.validateRadios(form, 'q3');
				let q4 = this.validateRadios(form, 'q4');
				let q5 = this.validateRadios(form, 'q5');
				if(q1 && q2 && q3 && q4 && q5){
					console.log('success!')
				} else {
					e.preventDefault();
					alert('Bitte alle Felder ausfüllen!');
				}
			});
		}
	}

	validateRadios(form, radioName) {
		var radios = document.getElementsByName(radioName);
		console.log(radios);
		for (var i = 0, len = radios.length; i < len; i++) {
			if (radios[i].checked) {
				return true;
			}
		}
	}
}

export default Survey;
